module.exports = rrule;